export const seriesNameMap: Record<string, string> = {
  consumption_total: 'Consumo Total',
  private_company_count: 'Privado',
  public_company_count: 'Público',
  total_amount_sum: 'Total em vendas',
}

export function translateSeriesName(key: string): string {
  return seriesNameMap[key] ?? key
}